import React, { useState, useEffect, ReactElement } from 'react';
import { Spinner } from 'react-bootstrap';
import { Resolver } from '../../models/interfaces/Resolver';
import ErrorMessageView from './ErrorMessageView';

interface Props<T> {
    resolver: Resolver<T>;
    itemTranslator: (T) => ReactElement;
}

export default function ResolverView<T>({ resolver, itemTranslator }: Props<T>) {
    const [hasResolvedItem, setHasResolvedItem] = useState(resolver.hasResolved);
    const [resolvedItem, setResolvedItem] = useState(resolver.resolvedObject);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
    useEffect(() => {
        const token = resolver.resolve(
            (updatedItem) => {
                setHasResolvedItem(true);
                setResolvedItem(updatedItem);
            },
            (resolverError) => {
                setHasResolvedItem(true);
                setErrorMessage(resolverError);
            }
        );
        return () => {
            resolver.cancel(token);
        };
    }, [resolver]);
    if (resolvedItem) {
        return itemTranslator(resolvedItem);
    } else if (errorMessage) {
        return <ErrorMessageView>{errorMessage}</ErrorMessageView>;
    } else if (!hasResolvedItem) {
        return <Spinner key={resolver.id} animation="border" />;
    } else {
        return (
            <ErrorMessageView key={resolver.id}>
                An unexpected resolver error occurred
            </ErrorMessageView>
        );
    }
}
